import React from 'react';

import type { DTBContentBlock, VideoContentBlock, TextContentBlock } from '../../../_types/dtb';
import ContentBlockPreview from './ContentBlockPreview';
import VideoBlockPreview from './VideoBlockPreview';

interface BlockPreviewProps {
  block: DTBContentBlock;
}

const BlockPreview: React.FC<BlockPreviewProps> = ({ block }) => {
  switch (block.contentType) {
    case 'VIDEO':
      return <VideoBlockPreview block={block as VideoContentBlock} />;
    case 'CONTENT':
      return <ContentBlockPreview block={block as TextContentBlock} />;
    default:
      // Exhaustive check - if we add new block types, TypeScript will warn us here
      const _exhaustiveCheck: never = block;
      return null;
  }
};

export default BlockPreview;
